import React, { useEffect } from "react";
import MaterialTable from "material-table";
import { Strings } from "../../assets/res/en";
import useUsers from "../../hooks/modules/user/useUsers";
import useTableIcons from "../../hooks/useTableIcons";
import { SearchBar } from "../../components/searchBox/SearchBar";
import { Chip, LinearProgress } from "@material-ui/core";
import useStyles from "../../hooks/useStyles";
import { ModalDialog, ToolBar } from "../../components/tools";
import Unauthorized from "../../components/Unauthorized";

export default function User() {
  const classes = useStyles();
  const { tableIcons } = useTableIcons();
  const {
    users,
    isLoading,
    getAllUsers,
    searchOptions,
    columns,
    sytlingOptions,
    actions,
    filters,
    searchData,
    openDialog,
    handleModalClose,
    handleActionClick,
    modalHeader,
    modalContent,
    modalActions,
    modalFormResetKeys,
    modalTaskRunning,
    modalFormError,
    userPermission,
  } = useUsers();
  useEffect(() => {
    getAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {userPermission.read === true ? (
        <>
          <SearchBar options={searchOptions} />
          <MaterialTable
            title={Strings.COLUMN_USER_TITLE}
            icons={tableIcons}
            columns={columns}
            actions={actions}
            data={users}
            options={sytlingOptions}
            isLoading={isLoading}
            localization={{
              body: {
                editRow: { deleteText: Strings.COLUMN_USER_DELETE_TEXT },
              },
            }}
            components={{
              Toolbar: (props) => (
                <div>
                  <ToolBar
                    {...props}
                    onAction={handleActionClick}
                    canCreate={userPermission?.create ?? false}
                  />
                  <div
                    className={
                      filters.filter(
                        (item) =>
                          item.value && item.value.toString().trim() !== ""
                      ).length > 0
                        ? classes.filterContainer
                        : ""
                    }
                  >
                    {filters.filter(
                      (item) =>
                        item.value && item.value.toString().trim() !== ""
                    ).length > 0 &&
                      filters
                        .filter(
                          (item) =>
                            (item.value &&
                              item.value.toString().trim() !== "") ||
                            item.isClearAll === true
                        )
                        .map((fItem) =>
                          fItem.isClearAll === true ? (
                            <Chip
                              key={fItem.name}
                              color="secondary"
                              label="Reset All Filters"
                              onClick={() => fItem.clearAll(filters)}
                            />
                          ) : (
                            <Chip
                              key={fItem.name}
                              color="default"
                              label={fItem.value}
                              onDelete={() =>
                                fItem.remove(fItem, filters, searchData)
                              }
                            />
                          )
                        )}
                  </div>
                </div>
              ),
            }}
          />
          <ModalDialog
            open={openDialog}
            handleClose={handleModalClose}
            modalHeader={modalHeader}
            modalContent={modalContent}
            modalActions={modalActions}
            modalFormResetKeys={modalFormResetKeys}
            modalTaskRunning={modalTaskRunning}
            modalFormError={modalFormError}
          />
        </>
      ) : userPermission.read === false ? (
        <Unauthorized />
      ) : (
        <LinearProgress />
      )}
    </>
  );
}
